import React, { useState } from 'react';
// @ts-ignore
import styles from './QuestionnaireOverviewListItem.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import QuestionnairePlanningModal from '../QuestionnairePlanning/QuestionnairePlanningModal';
import QuestionnairePreviewModal from '../QuestionnairePreview/QuestionnairePreviewModal';
import { Questionnaire } from '../../Interfaces/Questionnaire.interface';

interface Props {
	item: Questionnaire;
}

const QuestionnaireOverviewListItem: React.FC<Props> = ({ item }) => {
	const [isPlanningOpen, setIsPlanningOpen] = useState(false);
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div className={styles.title}>{item.title}</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						title='component.questionnaires.settingUp'
						theme={Theme.BLUE}
						onClick={() => setIsPlanningOpen(true)}
					/>
					<LinkButton
						title='base.preview'
						theme={Theme.BLUE}
						onClick={() => setIsPreviewOpen(true)}
					/>
				</div>
			</div>
			{isPlanningOpen && (
				<QuestionnairePlanningModal
					opened
					onClose={() => setIsPlanningOpen(false)}
					questionnaireId={item.id}
				/>
			)}
			{isPreviewOpen && (
				<QuestionnairePreviewModal
					isOpen
					onClose={() => setIsPreviewOpen(false)}
					questionnaireId={item.id}
				/>
			)}
		</>
	);
};

export default QuestionnaireOverviewListItem;
